import React from 'react';
import './experience.css';
import { BsPatchCheckFill } from 'react-icons/bs';

const Experience = () => {
  return (
    <section id='experience'>
      <h5>Professional Journey</h5>
      <h2>Work Experience</h2>

      {/* Work Experience Section - Centered with reduced width */}
      <div className="work-experience__wrapper">
        <div className="work-experience__container">
          <div className="work-experience__card">
            <div className="work-experience__header">
              <div className="work-experience__role">Backend Developer</div>
              <div className="work-experience__company">TCS</div>
              <div className="work-experience__date">04/2025 - Current</div>
            </div>
            <ul className="work-experience__details">
              <li>Developed backend components in the <strong>Payments domain</strong> at a Nordic Bank, supporting systems including <strong>C54D, C53, and IBIS</strong>.</li>
              <li>Engineered a <strong>high-throughput polling service</strong> for the Sweden value chain by consuming Kafka topics, processing real-time payment events, and persisting them into a payment data store with high reliability and low latency.</li>
              <li>Designed and developed <strong>scalable Java backend services</strong> using Spring Boot, Spring Cloud, and Microservices architecture for large-scale payment processing.</li>
              <li>Built and integrated <strong>RESTful APIs</strong> enabling seamless communication across internal payment systems and third-party services.</li>
              <li>Performed <strong>API testing and validation</strong> using Bruno, ensuring correctness and reliability of service endpoints.</li>
              <li>Deployed and managed applications on <strong>AWS (EC2, AWS Lambda)</strong>, achieving scalable, fault-tolerant, and highly available backend systems.</li>
              <li>Developed <strong>unit and integration test suites</strong> using JUnit and Mockito, and executed system testing using Docker and Nginx.</li>
              <li>Contributed to <strong>CI/CD pipelines</strong> and end-to-end API integration, improving deployment efficiency and system stability.</li>
              <li>Built a <strong>Python-based monitoring solution</strong> using AWS Lambda with Dynatrace integration for real-time health checks, failure detection, and automated alerting via AWS SES, Secrets Manager, MySQL/JDBC, and InfluxDB.</li>
              <li>Implemented <strong>Auto Scaling lifecycle automation</strong> using ASG lifecycle hooks, SNS, and Lambda to update Dynatrace dashboards, eliminating false alerts during EC2 instance termination.</li>
              <li>Designed and managed <strong>MySQL database migrations</strong> using Alembic, including stored procedures, triggers, and scheduled jobs for failure monitoring integrated with AWS services.</li>
            </ul>
          </div>

          <div className="work-experience__card">
            <div className="work-experience__header">
              <div className="work-experience__role">Graduate Engineer Trainee</div>
              <div className="work-experience__company">Vedanta Group(ESL Limited)</div>
              <div className="work-experience__date">09/2024 - 11/2024</div>
            </div>
            <ul className="work-experience__details">
              <li>Six-month training program</li>
              <li>Hands-on experience with manufacturing software technologies</li>
              <li>Worked in fast-paced IT team environment</li>
            </ul>
          </div>

          {/* Added Internships */}
          <div className="work-experience__card">
            <div className="work-experience__header">
              <div className="work-experience__role">R&D Intern</div>
              <div className="work-experience__company">Keysight Technologies</div>
              <div className="work-experience__date">01/2024 - 06/2024</div>
            </div>
            <ul className="work-experience__details">
              <li>Developed Python automation suite using Pytest and Eggplant</li>
              <li>Enhanced testing efficiency and reduced manual testing hours</li>
              <li>Tested PCIe 5.0 and PCIe 6.0 technologies</li>
              <li>Used Jenkins, Python, Git, Jira, Bitbucket, Confluence</li>
            </ul>
          </div>

          <div className="work-experience__card">
            <div className="work-experience__header">
              <div className="work-experience__role">SDE Intern</div>
              <div className="work-experience__company">TRAILSHOPY Pvt. Ltd.</div>
              <div className="work-experience__date">05/2023 - 07/2023</div>
            </div>
            <ul className="work-experience__details">
              <li>Increased web app performance by 20% with optimized CRUD operations</li>
              <li>Improved user experience by streamlining backend processes</li>
              <li>Reduced response times through route optimization</li>
            </ul>
          </div>
        </div>
      </div>

      <h5 className="skills-subtitle">Technical Skills</h5>
      <h2>My Expertise</h2>

      <div className="skills__container">
        <div className="skills__frontend">
          <h3>Web Development</h3>
          <div className="skills__content">
            <article className="skills__details">
              <BsPatchCheckFill className='skills__details-icon'/>
              <div>
                <h4>HTML/CSS</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className="skills__details">
              <BsPatchCheckFill className='skills__details-icon'/>
              <div>
                <h4>JavaScript</h4>
                <small className='text-light'>Basic</small>
              </div>
            </article>
            <article className="skills__details">
              <BsPatchCheckFill className='skills__details-icon'/>
              <div>
                <h4>Node.Js</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className="skills__details">
              <BsPatchCheckFill className='skills__details-icon'/>
              <div>
                <h4>Express.Js</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className="skills__details">
              <BsPatchCheckFill className='skills__details-icon'/>
              <div>
                <h4>FastAPI</h4>
                <small className='text-light'>Basic</small>
              </div>
            </article>
            <article className="skills__details">
              <BsPatchCheckFill className='skills__details-icon'/>
              <div>
                <h4>Bootstrap</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className="skills__details">
              <BsPatchCheckFill className='skills__details-icon'/>
              <div>
                <h4>ReactJS</h4>
                <small className='text-light'>Basic</small>
              </div>
            </article>
            <article className="skills__details">
              <BsPatchCheckFill className='skills__details-icon'/>
              <div>
                <h4>Flask</h4>
                <small className='text-light'>Basic</small>
              </div>
            </article>
          </div>
        </div>

        <div className="skills__lang">
          <h3>Languages, Tools & Fundamentals</h3>
          <div className="skills__content">
            <article className="skills__details">
              <BsPatchCheckFill className='skills__details-icon'/>
              <div>
                <h4>JAVA</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className="skills__details">
              <BsPatchCheckFill className='skills__details-icon'/>
              <div>
                <h4>SpringBoot</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className="skills__details">
              <BsPatchCheckFill className='skills__details-icon'/>
              <div>
                <h4>Apache Kafka</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className="skills__details">
              <BsPatchCheckFill className='skills__details-icon'/>
              <div>
                <h4>Python</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className="skills__details">
              <BsPatchCheckFill className='skills__details-icon'/>
              <div>
                <h4>RAG</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className="skills__details">
              <BsPatchCheckFill className='skills__details-icon'/>
              <div>
                <h4>AWS</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className="skills__details">
              <BsPatchCheckFill className='skills__details-icon'/>
              <div>
                <h4>Nginx</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className="skills__details">
              <BsPatchCheckFill className='skills__details-icon'/>
              <div>
                <h4>DSA</h4>
                <small className='text-light'>Advanced</small>
              </div>
            </article>
            <article className="skills__details">
              <BsPatchCheckFill className='skills__details-icon'/>
              <div>
                <h4>OOPS</h4>
                <small className='text-light'>Advanced</small>
              </div>
            </article>
            <article className="skills__details">
              <BsPatchCheckFill className='skills__details-icon'/>
              <div>
                <h4>Operating System</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className="skills__details">
              <BsPatchCheckFill className='skills__details-icon'/>
              <div>
                <h4>DBMS</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className="skills__details">
              <BsPatchCheckFill className='skills__details-icon'/>
              <div>
                <h4>Mysql</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className="skills__details">
              <BsPatchCheckFill className='skills__details-icon'/>
              <div>
                <h4>Git & GitHub</h4>
                <small className='text-light'>Basic</small>
              </div>
            </article>
            <article className="skills__details">
              <BsPatchCheckFill className='skills__details-icon'/>
              <div>
                <h4>ML</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;